import { List, ListItem, ListItemText, ListItemButton, ListItemIcon, Divider, Grid, Typography } from "@mui/material";
import MobileUpBar from "../../components/mobileUpBar";
import demo_owners from '../../datasets/owners';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import api from "../../hooks/useApi";
import PageTitle from "../../components/PageTitle";
import {requireSuperAdmin} from "../../auth/guards";


export async function loader({ request, params }) {
    const authResult = await requireSuperAdmin({request, params});
    if (authResult instanceof Response) return authResult;
    const response = await api.get('/api/hotels/group/owner/get/');
    const users = response.data?.users;
    if (!Array.isArray(users)) {
        throw new Response('Некоректна відповідь списку власників', {status: 502});
    }
    const initialCards = users.map((card) => ({
        ...card,
        cities: Array.isArray(card.cities) ? card.cities : [],
        classifications: Array.isArray(card.classifications) ? card.classifications : [],
    }));
    return { initialCards };
}


export default function OwnersMobile() {
    const {initialCards} = useLoaderData();
    return (
        <>
            <PageTitle title="Власники (мобільна версія)" />
            <MobileUpBar />
            {initialCards.length === 0 ? <Typography sx={{p: 2}}>Партнерів поки немає.</Typography> : <List>
                {initialCards.map((el) => (
                    <OwnerListItem data={el} key={el.id} />
                ))}
            </List>}
        </>
    );
}
const OwnerListItem = ({ data }) => {
    const [open, setOpen] = useState(false);
    const handleListItemClick = () => {
        setOpen((prev) => !prev)
    }
    return (
        <>
            <ListItemButton onClick={handleListItemClick} disableRipple>
                <ListItemText>
                    {data.name}
                </ListItemText>
                <ListItemIcon>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemIcon>
            </ListItemButton>

            {open && (
                <ListItem>
                    <Grid container>
                        <Grid item container>
                            <ListItemText>
                                <Typography variant='body2'>
                                    {data.email}
                                </Typography>
                            </ListItemText>
                            {/* <ListItemIcon>
                                <EditOutlinedIcon style={{ cursor: 'pointer' }} />
                            </ListItemIcon> */}
                        </Grid>
                        <Grid item container>
                            <Typography variant='body2'>
                                {data.phone}
                            </Typography>

                        </Grid>
                        <Grid item container>
                            <Typography variant='body2'>
                                Об'єкти розташовані в: {data.cities.join(', ')}
                            </Typography>

                        </Grid>
                        <Grid item container>
                            <Typography variant='body2'>
                                Класифікації об'єктів: {data.classifications.join(', ')}
                            </Typography>

                        </Grid>
                    </Grid>
                </ListItem>
            )}
            <Divider orientation='horizontal' />
        </>
    );
}
